/**
 * Sentinel written into a template's `editorState` whenever the template is saved from the new
 * {@link TemplateEditor}. The legacy Draft.js editor checks for this exact value and, when it is
 * present, refuses to edit the template inline — directing users to the new editor instead —
 * because a non–Draft.js `editorState` would otherwise be mis-parsed and corrupt the body.
 *
 * This constant is the single source of truth for the marker; the legacy UI must compare against
 * the same literal. The new editor never stores reconstruction data in `editorState` — `html` and
 * `message` are the only round-trip sources of truth. The `TELLESCOPE_2_` prefix matches the
 * convention used elsewhere for new-UI markers (e.g. `TELLESCOPE_2_TABLE_VIEW_PREFIX`).
 */
export const NEW_EDITOR_STATE_SENTINEL = "TELLESCOPE_2_TEMPLATE_EDITOR";

/** True when the given `editorState` was written by the new (Tellescope 2) template editor. */
export const isNewEditorState = (editorState: string | undefined | null): boolean =>
  editorState === NEW_EDITOR_STATE_SENTINEL;
